import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { getProfile, getActivity, getUserSettings, getAcceptedAgreements } from '../../../../common/services/http/userService';
import Main from '../../../layout/main/main';

import ContactDetails from '../../components/contactDetails/contactDetails';

import useTranslate from '../../../../common/hooks/useTranslate';
import UserSettings from '../../components/userSettings/userSettings';
import ActivityLog from '../../components/activityLog/activityLog';

import './profile.scss';
import AcceptedAgreements from '../../components/acceptedAgreements/acceptedAgreements';

export interface IEmail {
  id: number;
  entityId: number;
  address: string;
  label: string;
  isPrimary: boolean;
}

export interface IPhones {
  id: number;
  entityId: number;
  address: string;
  label: string;
  isPrimary: boolean;
  number: string;
}

export interface IAddresses {
  address1?: string;
  address2?: string;
  city?: string;
  country?: string;
  countryCode?: string;
  entityId?: string;
  id?: string;
  label?: string;
  postalCode?: string;
  state?: string;
}

export interface IProfile {
  id: number;
  firstName: string;
  lastName: string;
  fullName?: string;
  emails: IEmail[];
  phones: IPhones[];
  addresses: IAddresses[];
}

const Profile: React.FC = () => {
  const { t } = useTranslate();
  const [activity, setActivity] = useState([]);
  const [acceptedAgreements, setAcceptedAgreements] = useState([])
  const [userSettings, setUserSettings] = useState([]);
  const [profile, setProfile] = useState<IProfile>({
    id: 0,
    firstName: '',
    lastName: '',
    emails: [],
    phones: [],
    addresses: [],
  });
  const [loadingProfile, setLoadingProfile] = useState<boolean>(true);
  const [loadingActivity, setLoadingActivity] = useState<boolean>(true);
  const [loadingAgreements, setLoadingAgreements] = useState<boolean>(true);
  const [screenSize, setScreenSize] = useState<number>(0);

  const impersonate = useSelector((state: RootState) => state.impersonate);
  getAcceptedAgreements;

  useEffect(() => {
    setScreenSize(screen.width);
    getProfile().then((r) => {
      setProfile(r.data[0]);
      setLoadingProfile(false);
    });
    getActivity().then((r) => {
      setActivity(r.data);
      setLoadingActivity(false);
    });
    getUserSettings().then((res) => {
      setUserSettings(res);
    });

    getAcceptedAgreements().then((res) => {
      setAcceptedAgreements(res)
      setLoadingAgreements(false)
    });
  }, [impersonate]);

  return (
    <Main title={`${screenSize < 960 ? profile.firstName + ' ' + profile.lastName : t('PROFILE.PAGE_TITLE')}`}
          additionalTitle={`${screenSize < 960 ? '' : profile.firstName + ' ' + profile.lastName}`}>
      <div className="profile-wrapper">
        <ContactDetails profile={profile} loadingProfile={loadingProfile} />
        <UserSettings settings={userSettings} />
        <ActivityLog activity={activity} loadingActivity={loadingActivity} />
        <AcceptedAgreements data={acceptedAgreements} loadingActivity={loadingAgreements} />
      </div>
    </Main>
  );
};

export default Profile;
